import * as R from "ramda";

import { createHandlers } from "redux-mvc";

import { NAMESPACE, TAB_IDS } from "./constants";

const iniState = {
  loading: true,
  loadingFileUpload: true,
  loadingMessages: true,
  record: {},
  taskData: {},
  taskSessionId: null,
  showEmptyState: false,
  showNoResults: false,
  selectedTab: TAB_IDS.DETAILS,
  tabStats: Object.values(TAB_IDS).reduce(
    (acc, val) => ({ ...acc, [val]: 0 }),
    {}
  ),
  // fileUpload
  fileUploadData: undefined,
  fileUploadProgress: 0,
  fileUploadUploadHasFinished: true,
  loadingSavingFile: false,
  files: [],
  //messages
  messages: []
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    search: R.identity,
    closeTaskFlyOver: R.identity,
    onOpen: R.identity,
    viewMore: R.identity,
    openTaskFlyOver: R.identity,
    executeAction: R.identity,
    refreshData: R.identity,

    initFileRequest: R.identity,
    setInitialData: (_, { payload: { taskData, taskSessionId } }) => ({
      taskData,
      taskSessionId: taskSessionId ? taskSessionId : null
    }),
    resetData: R.always(iniState),

    // fileUpload reducers
    loadingSavingFile: R.identity,
    initFileUpload: R.identity,
    fileUploadRemoveUploadedUrls: R.identity,
    onFileSelected: R.identity,
    onFileUploadProgress: R.identity,
    onFileUploadCancel: R.identity,
    onFileUploadFailed: R.identity,
    onFileUploadFinished: R.identity,
    updateFileUploadFileData: R.identity,
    validateFileUploadUrl: R.identity,
    addFileUploadUrl: R.identity,
    cancelFileUploadUrl: R.identity,
    saveFileUpload: R.identity,
    cancelFileUpload: R.identity,
    cleanFileUploadState: () => ({
      fileUploadData: undefined,
      fileUploadProgress: 0,
      fileUploadUploadHasFinished: true,
      loadingSavingFile: false
    }),

    toggleTaskStatus: ({ taskData }) => ({
      taskData: {
        ...taskData,
        is_complete: taskData.status === "complete" ? false : true,
        status: taskData.status === "complete" ? "incomplete" : "complete"
      }
    }),

    // messages reducers
    initMessages: R.identity,
    sendMessage: R.identity
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
